import { useEffect, useState } from 'react';
import { t } from 'src/i18n';
import cx from 'classnames';
import { Wrapper, Button, Icon, ShortcutsContainer, SearchText, ShortcutKey } from './globalSearchButton.style';
import IconK from '../../../assets/svg/icon-k.svg';
import IconCmd from '../../../assets/svg/icon-cmd.svg';
import IconCtrl from '../../../assets/svg/icon-ctrl.svg';
import IconSearch from '../../../assets/icons/sidebar/global-search.svg';

const GlobalSearchButton = ({ toggleGlobalSearchVisibility, collapsed }) => {
  const [isWindows, setIsWindows] = useState(false);

  useEffect(() => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const isWindowsOS = userAgent.indexOf('windows') !== -1;
    setIsWindows(isWindowsOS);
  }, []);

  const buttonClassNames = cx({
    ['global-search-button-collapsed']: collapsed,
  });

  return (
    <Wrapper>
      <Button onClick={toggleGlobalSearchVisibility} className={buttonClassNames}>
        <Icon>
          <img alt="" src={IconSearch} />
        </Icon>
        {!collapsed && (
          <>
            <SearchText>{t('dash.globalSearch.search_label')}</SearchText>
            <ShortcutsContainer>
              {!isWindows && (
                <ShortcutKey>
                  <img alt="" src={IconCmd} />
                </ShortcutKey>
              )}
              {isWindows && (
                <ShortcutKey className="key-windows">
                  <img alt="" src={IconCtrl} />
                </ShortcutKey>
              )}
              <ShortcutKey>
                <img alt="" src={IconK} />
              </ShortcutKey>
            </ShortcutsContainer>
          </>
        )}
      </Button>
    </Wrapper>
  );
};

export default GlobalSearchButton;
